module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("a2bGP"))).then(() => parcelRequire('1iHdE'));